import { AxiosResponse } from 'axios';
import { ErrorResponse } from 'generated';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { deletePool } from 'RestAPIs/poolMaintenance';

import { showSnackbar } from 'components/shared';

export const useDeletePool = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useMutation<AxiosResponse, ErrorResponse, number>({
    mutationFn: deletePool,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['poolMaintenance', 'list']
      });
      showSnackbar({ message: t('poolMaintenance.delete.succeed') });
    },
    onError: () => {
      showSnackbar({
        severity: 'error',
        message: t('poolMaintenance.delete.failed')
      });
    }
  });
};
